import React from 'react'
import { Alert, Button, IconButton } from '~/shared/ui'
import { useReleaseNotes } from '../api'
import { useReleaseNotesSelectors } from '../model'

function ReleaseNotesBanner() {
  const { setIsPopupOpen, lastDismissedReleaseNoteVersion, setLastDismissedReleaseNoteVersion } =
    useReleaseNotesSelectors()
  const {
    data: { data: releaseNotes = [] },
  } = useReleaseNotes()
  const latestReleaseNote = releaseNotes.sort((a, b) => b.Version.localeCompare(a.Version))[0]

  if (!latestReleaseNote || lastDismissedReleaseNoteVersion === latestReleaseNote.Version) {
    return null
  }

  return (
    <Alert
      className="rounded-none"
      appearance="INFO"
      materialIcon={{ children: 'info', fill: true }}
      caption={latestReleaseNote.Title}
      action={
        <div className="flex items-center gap-6">
          <Button
            size="small"
            onClick={() => setIsPopupOpen(true)}
          >
            Learn More
          </Button>
          <IconButton
            className="text-info-main"
            size="medium"
            container="small"
            materialIcon="close"
            onClick={() => setLastDismissedReleaseNoteVersion(latestReleaseNote.Version)}
          />
        </div>
      }
    >
      {latestReleaseNote.Description}
    </Alert>
  )
}

export function ReleaseNotesBannerSuspended() {
  return (
    <React.Suspense>
      <ReleaseNotesBanner />
    </React.Suspense>
  )
}
